export default __webpack_public_path__ + "static/media/logo.4717fa84.png";